import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from 'sonner';
import api, { apiError } from '../lib/api';

// Dialog CONTRÔLÉ pour rattacher une vente « à rattacher » à un fan : choisir le modèle
// → chercher le fan → rattacher. Utilisable par le popup de vente (chatteurs inclus :
// PATCH /sales en pose-conversation seule est autorisé pour eux). `sale` non-null = ouvert.
export default function AttributeFanDialog({ sale, accounts, onClose, onDone }) {
  const [model, setModel] = useState('');
  const [convs, setConvs] = useState([]);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => { setModel(sale?.account_id || ''); setQ(''); }, [sale]);
  useEffect(() => {
    if (!sale || !model) { setConvs([]); return undefined; }
    let alive = true; setLoading(true);
    api.get('/conversations', { params: { account_id: model } })
      .then(({ data }) => { if (alive) setConvs(data || []); })
      .catch(() => { if (alive) setConvs([]); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [sale, model]);

  const list = (q ? convs.filter(c => (c.name || '').toLowerCase().includes(q.toLowerCase())) : convs).slice(0, 60);

  const attach = async (convId, force = false) => {
    setSaving(true);
    try {
      const { data } = await api.patch(`/sales/${sale.id}`, { conversation_id: convId, ...(force ? { force_conflict: true } : {}) });
      toast.success('Vente rattachée au fan');
      if (onDone) onDone(data);
      onClose();
    } catch (e) {
      // Garde-fou serveur : ce payeur est déjà relié à un AUTRE fan → confirmation explicite.
      if (e?.response?.status === 409) {
        const msg = e.response?.data?.detail || 'Ce payeur est déjà relié à un autre fan.';
        if (window.confirm(`⚠️ ${msg}\n\nRattacher quand même à ce fan ?`)) {
          setSaving(false);
          return attach(convId, true);
        }
      } else toast.error(apiError(e, 'Échec du rattachement'));
    }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={!!sale} onOpenChange={v => !v && onClose()}>
      <DialogContent className="bg-[#0B0B0E] border-white/10 text-slate-200">
        <DialogHeader><DialogTitle className="text-white">Rattacher la vente à un fan</DialogTitle></DialogHeader>
        {sale && (
          <div className="space-y-3 pt-1">
            <div className="text-xs text-slate-400">{(sale.amount || 0)} € · {sale.client || '—'}</div>
            <div className="space-y-1.5">
              <Label className="text-slate-300 text-xs">Modèle</Label>
              <select data-testid="popup-attribute-model" value={model} onChange={e => { setModel(e.target.value); setQ(''); }} className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm text-white h-10 outline-none">
                <option value="" className="bg-[#0B0B0E]">Choisir un modèle…</option>
                {(accounts || []).map(a => <option key={a.id} value={a.id} className="bg-[#0B0B0E]">{a.name}</option>)}
              </select>
            </div>
            <div className="space-y-1.5">
              <Label className="text-slate-300 text-xs">Fan</Label>
              <Input data-testid="popup-attribute-search" value={q} onChange={e => setQ(e.target.value)} placeholder={model ? 'Rechercher un fan…' : "Choisis d'abord un modèle"} className="bg-white/5 border-white/10 text-white h-10" disabled={!model} />
            </div>
            <div className="max-h-64 overflow-y-auto rounded-lg border border-white/10 divide-y divide-white/5">
              {loading && <div className="px-3 py-3 text-xs text-slate-500">Chargement…</div>}
              {!loading && model && list.length === 0 && <div className="px-3 py-3 text-xs text-slate-500">Aucun fan trouvé.</div>}
              {list.map(c => (
                <button key={c.id} disabled={saving} onClick={() => attach(c.id)} className="w-full text-left px-3 py-2 text-sm text-white hover:bg-white/5 disabled:opacity-50">
                  {c.name || c.telegram_username || c.id}
                </button>
              ))}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
